// extracted by mini-css-extract-plugin
module.exports = {"title":"WalletsModal_title__20tOe","button":"WalletsModal_button__xg-XO","buttonText":"WalletsModal_buttonText__bC2uc"};